<template>
    <div v-if="this.$store.state.isMobile">
        <mt-header title="multiple button">
            <router-link to="/" slot="left">
                <mt-button icon="back">back</mt-button>
                <mt-button @click="handleClose">close</mt-button>
            </router-link>
            <mt-button icon="more" slot="right"></mt-button>
        </mt-header>
    </div>
</template>

<script>

    export default {
        name: "NavMenuMobile",
        components:{

        },
        methods:{
            handleClose(){

            }
        }
    }
</script>

<style scoped>

</style>